export default "__VITE_ASSET__CqfkLHPE__"